import React from 'react';
import BaseTableRow from '@material-ui/core/TableRow';

const TableRow = (props) => <BaseTableRow {...props} />;

export default TableRow;
